import React, { useEffect, useState } from "react";
import "./BannerSearch.css";




import hero1 from "./Images/IP1.jpg";
import hero2 from "./Images/Ip2.jpg";
import hero3 from "./Images/Ip3.jpg";

const images = [hero1, hero2, hero3];
// const images = [
//   "https://images.unsplash.com/photo-1568605114967-8130f3a36994",
//   "https://images.unsplash.com/photo-1501183638710-841dd1904471",
//   "https://images.unsplash.com/photo-1600585154340-be6161a56a0c",
// ];

export default function Hero() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((prev) => (prev + 1) % images.length);
    }, 4000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section
      className="hero"
      style={{ backgroundImage: `url(${images[active]})` }}
    >
      <div className="hero-overlay">
        <h1>
          Your Property Is <br /> Our Priority
        </h1>
        <p>
          A small river named Duden flows by their place and supplies it with the
          necessary regelialia.
        </p>

        {/* Slider dots */}
        <div className="slider-dots">
          {images.map((_, i) => (
            <span
              key={i}
              className={active === i ? "dot active" : "dot"}
              onClick={() => setActive(i)}
            ></span>
          ))}
        </div>
      </div>
    </section>
  );
}
